import { render, staticRenderFns } from "./xuanchuan.vue?vue&type=template&id=aa1104a2"
var script = {}
import style0 from "./xuanchuan.vue?vue&type=style&index=0&id=aa1104a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports